import React, { Component } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import intlShape from '@/shared/utils/intlShape';
import ZendeskHelp from '@/shared/components/ZendeskHelp';
import Button from './Button';

const messages = defineMessages({
  Ok: 'Ok',
  Cancel: 'Cancel',
});

class OkCancelModal extends Component {
  static propTypes = {
    title: PropTypes.node,
    show: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    disabled: PropTypes.bool,
    intl: intlShape.isRequired,
    size: PropTypes.string,
    okLabel: PropTypes.node,
    cancelLabel: PropTypes.node,
    disableFullScreen: PropTypes.bool,
    leftButton: PropTypes.node,
    dismissOnClickOutsideModal: PropTypes.bool,
    onHoverSave: PropTypes.func,
    zendeskArticle: PropTypes.string,
    cancelDisabled: PropTypes.bool,
    customClassName: PropTypes.string,
    onEnter: PropTypes.func,
  };

  static defaultProps = {
    title: '',
    show: false,
    size: '',
    disabled: false,
    cancelDisabled: false,
    okLabel: undefined,
    cancelLabel: undefined,
    disableFullScreen: false,
    dismissOnClickOutsideModal: false,
    onHoverSave: () => {},
    zendeskArticle: null,
    customClassName: '',
    onEnter: () => {},
  };

  state = {
    fullScreen: false,
  };

  render() {
    const {
      title,
      show,
      onClose,
      onSave,
      children,
      disabled,
      intl,
      size,
      okLabel,
      cancelLabel,
      disableFullScreen,
      leftButton,
      onHoverSave,
      dismissOnClickOutsideModal,
      zendeskArticle,
      cancelDisabled,
      customClassName,
      onEnter,
    } = this.props;
    const { fullScreen } = this.state;

    return (
      <Modal
        enforceFocus={false} // set this to false so other modals can be shown on top of this one and be editable
        backdrop={dismissOnClickOutsideModal ? true : 'static'}
        show={show}
        className={customClassName}
        onHide={onClose}
        autoFocus={true}
        onEnter={onEnter}
        dialogClassName={classNames(customClassName, {
          'modal-lg': size === 'lg',
          'modal-xl': size === 'xl',
          'full-screen': fullScreen,
        })}
      >
        <Modal.Header closeButton>
          {!disableFullScreen && (
            <button
              type="button"
              className="toggle-full-screen"
              onClick={() => this.setState(state => ({ fullScreen: !state.fullScreen }))}
            >
              <i
                className={classNames('fa', {
                  'fa-compress': fullScreen,
                  'fa-expand': !fullScreen,
                })}
              />
            </button>
          )}
          <Modal.Title>
            {title}{' '}
            {zendeskArticle && <ZendeskHelp article={zendeskArticle} className="margin5L" />}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <div className="pull-left">{leftButton}</div>

          <Button onClick={onClose} name="OkCancelModal-Cancel" disabled={cancelDisabled}>
            {cancelLabel || intl.formatMessage(messages.Cancel)}
          </Button>
          <Button
            onClick={onSave}
            disabled={disabled}
            btnClassName="btn-inverse"
            onMouseOver={() => onHoverSave()}
            onFocus={() => onHoverSave()}
            showProgress
            name="OkCancelModal-Ok"
          >
            {okLabel || intl.formatMessage(messages.Ok)}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default injectIntl(OkCancelModal);
